import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';
import Doctor from './model-doctor';
import Dentist from './model-dentist';

const HealthData = Record({
    allergies: String(),
    allergiesHistory: [],
    diet: String(),
    dietHistory: [],
    other: String(),
    otherHistory: [],
    vaccines: String(),
    vaccinesHistory: [],
    toleratesPenicillin: String(),
    doctor: new Doctor.record(),
    dentist: new Dentist.record(),
    ssn: String(),
    behaviors: new BehaviorsCollection(),
    tetanusDate: String(),
    insuranceProvider: String(),
});

const UpdateToken = Record({
    token: null,
    expires: null,
});

const State = Record({
    healthData: new HealthData(),
    updateToken: null,
    hasAbortedPassword: false,
    loading: true,
    submitting: false,
    isEditing: false,
});

export default handleActions(
    {
        [Actions.exit.type]: () => new State(),

        [Actions.fetch.type]: () =>
            new State({
                loading: true,
            }),

        [Actions.fetchSuccess.type]: (state, {payload}) => {
            return state.merge({
                updateToken: payload.updateToken ? new UpdateToken(payload.updateToken) : null,
                healthData: new HealthData({
                    ...payload.health,
                    doctor: Doctor.fromAPI(payload.health.doctor),
                    dentist: Dentist.fromAPI(payload.health.dentist),
                    behaviors: new BehaviorsCollection(payload.health.behaviors),
                }),
                loading: false,
            });
        },

        [Actions.fetchAborted.type]: state =>
            state.merge({
                hasAbortedPassword: true,
                loading: false,
            }),

        [Actions.toggleEdit.type]: (state, {payload}) => state.merge({isEditing: payload.edit}),

        [Actions.update.type]: state => state.merge({submitting: true}),
        [Actions.updateFailed.type]: state => state.merge({submitting: false}),
        [Actions.updateSuccess.type]: (state, {payload}) => {
            return state.merge({
                submitting: false,
                isEditing: false,
                healthData: state.healthData.merge({
                    ...payload.rawFormData,
                    doctor: new Doctor.record(payload.rawFormData.doctor),
                    dentist: new Dentist.record(payload.rawFormData.dentist),
                }),
            });
        },
    },
    new State(),
);
